import {
  SIGNAL_SAMPLE_PLAYGROUND_RUN_LABEL,
  SIGNAL_SAMPLE_PLAYGROUND_RUN_TAG,
  SIGNAL_SAMPLE_REQUEST_FALLBACK_LABEL,
} from "./constants";

import { SignalSampleRequestLog } from "@/queries/signals";
import type { Request } from "@/types/requests";

type SignalSampleRequestSource = Pick<
  Request,
  "id" | "prompt_id" | "prompt_version_number" | "prompt_name" | "request_start_time" | "tags_array"
> & {
  prompt_preview?: string | null;
  request_response_preview?: string | null;
};

export const mapRequestToSignalSampleRequestLog = (
  request: SignalSampleRequestSource,
): SignalSampleRequestLog => ({
  id: request.id,
  prompt_id: request.prompt_id,
  prompt_version_number: request.prompt_version_number,
  prompt_name: request.prompt_name,
  tags_array: request.tags_array ?? null,
  prompt_preview: request.prompt_preview ?? null,
  request_response_preview: request.request_response_preview ?? null,
  request_start_time: request.request_start_time ?? null,
});

export const getSignalSampleRequestLabel = (requestLog: SignalSampleRequestLog): string => {
  if (requestLog.prompt_name) {
    return requestLog.prompt_name;
  }

  if (requestLog.tags_array?.includes(SIGNAL_SAMPLE_PLAYGROUND_RUN_TAG)) {
    return SIGNAL_SAMPLE_PLAYGROUND_RUN_LABEL;
  }

  return SIGNAL_SAMPLE_REQUEST_FALLBACK_LABEL;
};
